import PersonalizationCardImage from "../components/PersonalizationCardImage";
import PersonalizationInput from "../components/PersonalizationInput";
import PersonalizationTextarea from "../components/PersonalizationTextarea";
import React, {useEffect, useState} from "react";
import PersonalizationButton from "../components/PersonalizationButton";
import {useSelector} from "react-redux";
import Dropdown from "../../../../Admin Panel/Dropdown/Dropdown";
import TextInputLabel from "../../../../Comon/TextInputLabel/TextInputLabel";
import PersonalizationBoolean from "../components/PersonalizationBoolean";


export default function WellnessOpenScreen({showGlobalSnackbar, getWellnessError, wellnessFormData,setWellnessFormData}) {

    const app = useSelector((state) => state.app);
    const [showDeleteModal, setShowDeleteModal] = useState(false);


    const optionsTypes = app?.app_data?.wellnessOpenEndedQuestionTypes?.map(item => {
        return {
            ...item,
            name:item?.label,
        }
    });
    function getOptionTypeData(type){
        return optionsTypes?.find(item => item?.type === type);
    }

    const [options, setOptions] = useState(
        wellnessFormData?.openEndedQuestions ?? []
    );

    useEffect(() => {
        setWellnessFormData({
            ...wellnessFormData,
            openEndedQuestions: options
        });
    }, [options]);

    function addOption(){
        if(options?.length < 10){
            setOptions([...options, {
                type: optionsTypes?.[0]?.type,
                inputs: optionsTypes?.[0]?.inputs,
            }])
        }
    }
    function removeOption(index){
        setOptions(prevOptions => prevOptions.filter((_, i) => i !== index));
        setShowDeleteModal(false);
    }

    function updateOption(index, newData = {}){

        console.log('updateOption',index, newData);

        setOptions(prevOptions => prevOptions.map((option, i) => {
            if (i !== index) return option;
            return newData;
        }));
    }


    function updateOptionItemInput(itemIndex, inputIndex, newData = {}) {
        setOptions(prevOptions => prevOptions.map((option, i) => {
            if (i !== itemIndex) return option;

            const updatedInputs = option?.inputs?.map((inputItem, idx) => {
                if (idx !== inputIndex) return inputItem;
                return {
                    ...inputItem,
                    ...newData,
                };
            });

            return {
                ...option,
                inputs: updatedInputs,
            };
        }));
    }

    function moveOptionUp(index) {
        setOptions(prevOptions => {
            if (index <= 0) return prevOptions;

            const updated = [...prevOptions];
            const temp = updated[index - 1];
            updated[index - 1] = updated[index];
            updated[index] = temp;

            return updated;
        });
    }
    function moveOptionDown(index) {
        setOptions(prevOptions => {
            if (index >= prevOptions.length - 1) return prevOptions;

            const updated = [...prevOptions];
            const temp = updated[index + 1];
            updated[index + 1] = updated[index];
            updated[index] = temp;

            return updated;
        });
    }




    function addInputRepeatedOption(optionIndex, inputIndex) {
        setOptions(prevOptions => prevOptions.map((option, i) => {
            if (i !== optionIndex) return option;

            const updatedInputs = option?.inputs?.map((inputItem, idx) => {
                if (idx !== inputIndex) return inputItem;

                const currentValue = Array.isArray(inputItem?.value) ? inputItem.value : [];
                const max = inputItem?.max ?? Infinity;

                if (currentValue.length >= max) {
                    return inputItem;
                }

                const newValue = [
                    ...currentValue,
                    { label: "" },
                ];

                return {
                    ...inputItem,
                    value: newValue,
                };
            });

            return {
                ...option,
                inputs: updatedInputs,
            };
        }));
    }

    function removeInputRepeatedOption(optionIndex, inputIndex, inputRepeatedIndex) {
        setOptions(prevOptions => prevOptions.map((option, i) => {
            if (i !== optionIndex) return option;

            const updatedInputs = option?.inputs?.map((inputItem, idx) => {
                if (idx !== inputIndex) return inputItem;

                const currentValue = Array.isArray(inputItem?.value) ? inputItem.value : [];

                const newValue = currentValue.filter((_, idxRep) => idxRep !== inputRepeatedIndex);

                return {
                    ...inputItem,
                    value: newValue,
                };
            });

            return {
                ...option,
                inputs: updatedInputs,
            };
        }));
    }

    function updateInputRepeatedOption(optionIndex, inputIndex, inputRepeatedIndex, newValue) {
        setOptions(prevOptions => prevOptions.map((option, i) => {
            if (i !== optionIndex) return option;

            const updatedInputs = option?.inputs?.map((inputItem, idx) => {
                if (idx !== inputIndex) return inputItem;

                const currentValue = Array.isArray(inputItem?.value) ? inputItem.value : [];

                const newValueArray = currentValue.map((repItem, idxRep) => {
                    if (idxRep !== inputRepeatedIndex) return repItem;
                    return {
                        ...repItem,
                        label: newValue,
                    };
                });

                return {
                    ...inputItem,
                    value: newValueArray,
                };
            });

            return {
                ...option,
                inputs: updatedInputs,
            };
        }));
    }


    return <div style={{
        display: "flex",
        flexDirection: "column",
        gap:'20px'
    }}>
        <div
            style={{
                display:'flex',
                justifyContent:'space-between',
                alignItems:'center',
            }}
        >
            <h4 style={{margin:0,padding:0}}>Questions: {options?.length ?? '0'}</h4>
            <PersonalizationButton
                text={'Add New Question'}
                onClick={() => addOption()}
                color={options?.length >= 10 ? '#9c9c9c' : 'rgba(97, 132, 157, 1)'}
            />
        </div>

        {
            options?.length == 0 && <div
                style={{
                    padding: "40px",
                    borderRadius: "27px",
                    backgroundColor: "rgba(244, 244, 243, 1)",
                    position: "relative",
                    overflow: "hidden",
                    textAlign:'center',
                    paddingTop:'100px',
                    paddingBottom:'100px',
                }}
            >
                <h2>Create Your Questions</h2>
                <p>Click the button to add your first question. Choose the question type, set the answers, and build your list. You can add up to 10 questions in total.</p>
            </div>
        }

        {
            options?.map((item,index) => {
                const optionData = getOptionTypeData(item?.type);

                console.log('optionData inputs',optionData?.inputs);

                return <div
                    key={index}
                    style={{
                        padding: "40px",
                        borderRadius: "27px",
                        backgroundColor: "rgba(244, 244, 243, 1)",
                        position: "relative",
                        overflow: "hidden",
                    }}
                >


                    <TextInputLabel text={'Answer Type'} />

                    <div
                        style={{
                            display:'flex',
                            alignItems:'center',
                            justifyContent:'stretch',
                            gap:'20px',
                        }}
                    >
                        <div style={{
                            width:'100%'
                        }}>
                            <Dropdown
                                type={"wellnessOptionType"}
                                setSelectedOption={(option) => {
                                    updateOption(index, {...item, type: option?.type, inputs: option?.inputs})
                                }}
                                selectedOption={item?.type}
                                options={optionsTypes}
                                app={app}
                                placeholder={"Answer type"}
                            />
                        </div>

                        {
                            options?.length > 1 && <div style={{
                                marginTop:'5px',
                                display:'flex',
                                flexDirection:'column',
                                gap:'5px',
                            }}>

                                {
                                    index === 0 ? <div style={{width:'20px',height:'15px'}}/> :
                                        <img
                                            src={'/assets/carret_up.svg'}
                                            style={{width:'20px',height:'auto',cursor:'pointer'}}
                                            onClick={() => moveOptionUp(index)}
                                        />
                                }

                                {
                                    index === 9 ? <div style={{width:'20px',height:'15px'}}/> :
                                        <img
                                            src={'/assets/carret_down.svg'}
                                            style={{width:'20px',height:'auto',cursor:'pointer'}}
                                            onClick={() => moveOptionDown(index)}
                                        />
                                }

                            </div>
                        }

                    </div>



                    <div
                        style={{
                            marginTop:'10px',
                            marginBottom:'20px',
                            display: "flex",
                            flexDirection: "column",
                            gap:'10px'
                        }}
                    >
                        {item?.inputs?.map((inputItem,inputIndex) => {
                            return <div
                                key={`${index}_${inputIndex}`}
                            >
                                {
                                    inputItem?.type === 'textarea' && <div>
                                        <PersonalizationTextarea
                                            title={inputItem?.label}
                                            value={inputItem?.value}
                                            setValue={(value) => {
                                                updateOptionItemInput(index,inputIndex,{...inputItem, value: value})
                                            }}
                                        />
                                    </div>
                                }

                                {
                                    inputItem?.type.startsWith('boolean') && <div>
                                        <PersonalizationBoolean
                                            title={inputItem?.label}
                                            isChecked={inputItem?.value}
                                            setIsChecked={(value) => {
                                                updateOptionItemInput(index,inputIndex,{...inputItem, value: value})
                                            }}
                                        />
                                    </div>
                                }

                                {
                                    inputItem?.type === 'input' && <div>
                                        <PersonalizationInput
                                            title={inputItem?.label}
                                            value={inputItem?.value}
                                            setValue={(value) => {
                                                updateOptionItemInput(index,inputIndex,{...inputItem, value: value})
                                            }}
                                        />
                                    </div>
                                }

                                {
                                    inputItem?.type === 'input_repeated' &&
                                    <div
                                        style={{
                                            display:'flex',
                                            flexDirection:'column',
                                            gap:'10px',
                                            marginBottom:'30px'
                                        }}
                                    >
                                        {
                                            inputItem?.value?.map((inputRepeatedItem,inputRepeatedIndex) => {
                                                return <div
                                                    key={`${index}_${inputIndex}_${inputRepeatedIndex}`}
                                                    style={{
                                                        display:'flex',
                                                        gap:'10px',
                                                        alignItems:'center',
                                                        justifyContent:'stretch',
                                                    }}
                                                >
                                                    <div style={{width:'100%'}}>
                                                        <PersonalizationInput
                                                            title={`${inputItem?.input?.label} ${inputRepeatedIndex + 1}`}
                                                            value={inputRepeatedItem?.label}
                                                            setValue={(value) => {
                                                                updateInputRepeatedOption(index,inputIndex,inputRepeatedIndex,value)
                                                            }}
                                                            rightIcon={
                                                                inputRepeatedIndex > 0 &&
                                                                <img
                                                                    onClick={() => removeInputRepeatedOption(index,inputIndex,inputRepeatedIndex)}
                                                                    src={'/assets/trash_gray.svg'}
                                                                    style={{marginTop:'30px', width:'20px', height:'auto', cursor:'pointer'}}
                                                                />
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            })
                                        }

                                        {
                                            inputItem?.value?.length < 5 &&
                                            <div
                                                onClick={() => addInputRepeatedOption(index, inputIndex)}
                                                style={{
                                                    textDecoration:'underline',
                                                    cursor:'pointer',
                                                    color:'rgba(156, 156, 156, 1)',
                                                    paddingLeft:'30px',
                                                    marginTop:'10px',
                                                    marginBottom:'20px',
                                                }}
                                            >
                                                Add New
                                            </div>
                                        }
                                    </div>

                                }

                            </div>
                        })}
                    </div>


                    <PersonalizationButton
                        text={'Delete Question'}
                        onClick={() => setShowDeleteModal(index)}
                    />
                </div>
            })
        }

        <div
            style={{
                display:'flex',
                justifyContent:'center',
                alignItems:'center',
            }}
        >
            <PersonalizationButton
                text={'Add New Question'}
                onClick={() => addOption()}
                color={options?.length >= 10 ? '#9c9c9c' : 'rgba(97, 132, 157, 1)'}
            />
        </div>


        {
            showDeleteModal !== false &&
            <div className="ScreenOverlay">
                <div className="ScreenContent">
                    <h2>Delete Question</h2>
                    <p>Are you sure you want to delete this question?
                        This action can’t be undone.</p>

                    <button
                        style={{
                            border: 'none',
                            outline: 'none',
                            color: 'white',
                            minWidth: '300px',
                            padding: '7px 20px',
                            borderRadius: "23px",
                            boxShadow: "0px 2px 4px rgba(217, 217, 217, 1)",
                            backgroundColor: "rgba(97, 132, 157, 1)"
                        }}
                        onClick={() => {
                            removeOption(showDeleteModal)
                            showGlobalSnackbar('Successfully deleted question')
                        }}
                    >
                        Delete Question
                    </button>


                    <div
                        style={{
                            cursor: 'pointer',
                            margin: '10px',
                            textDecoration: 'underline',
                        }}
                        onClick={() => setShowDeleteModal(false)}
                    >
                        Cancel
                    </div>

                </div>
            </div>
        }


    </div>
}
